module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av33-ea98efecabdf8457311a72832a9c6c1a.jpg";